require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./basics-quick-start-guide.json") })
        }
      }, "path---basics-quick-start-guide");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---basics-quick-start-guide!./.cache/json/basics-quick-start-guide.json
// module id = 413
// module chunks = 231608221292675